(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kc-header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.kc-header__mobile a');
    if (link) link.closest('details').open = false;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.kc-header__mobile[open]');
    if (!menu) return;
    menu.open = false;
    menu.querySelector('summary').focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-kc-copy]');
    if (!button) return;
    const result = button.parentElement.querySelector('[role="status"]');
    try {
      await navigator.clipboard.writeText('COURIER10');
      result.textContent = button.dataset.success;
    } catch {
      result.textContent = 'COURIER10';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
